<template>
  <section class="mb-4" style="display: block">
    <div class="container">
      <div class="px-2 py-4 px-md-4 py-md-3 bg-white shadow-sm rounded">
        <div class="d-flex mb-3 align-items-baseline border-bottom">
          <h3 class="h5 fw-700 mb-0">
            <span
              class="border-bottom border-primary border-width-2 pb-3 d-inline-block"
              style="word-break: break-all"
              >{{ $t(title) }}</span
            >
          </h3>
          <a
            v-if="buttonName"
            class="ml-auto mr-0 btn btn-primary btn-sm shadow-md"
            href="javascript:void(0)"
            @click="jump(buttonHref)"
            >{{ $t(buttonName) }}</a
          >
        </div>
        <ProductsSlide :list="list" />
      </div>
    </div>
  </section>
</template>
<script>
import ProductsSlide from "@/components/ProductsSlide.vue";

export default {
  name: "TitleSlide",
  components: {
    ProductsSlide,
  },
  props: {
    title: String,
    buttonName: String,
    buttonHref: String,
    list: Array,
  },
};
</script>
